import useUser from 'store/user/useUser';

import Form from 'components/Form';
import RowContainer from '../Main/Survey/components/RowContainer';
import RowContent from '../Main/Survey/components/RowContent';

import { Typography, Stack, useTheme } from '@mui/material';

interface Props {
  disabled?: boolean;
  totalSize: number;
}

const StudentModeInfo = (props: Props) => {
  const { palette } = useTheme();

  const { totalSize } = props;
  const { student_name, student_no } = useUser();

  return (
    <RowContainer xs={20}>
      <RowContent title="Y tá" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          value={student_name}
          InputProps={{ readOnly: true }}
          sx={{ marginRight: '20px' }}
        />
      </RowContent>
      <RowContent title="Mã số sinh viên" titleRatio={1.5} childrenRatio={2}>
        <Form.MuiTextField value={student_no} InputProps={{ readOnly: true }} />
      </RowContent>
      <RowContent title="Dung lượng" titleRatio={1} childrenRatio={4.5}>
        <Stack direction="row" spacing={1}>
          <Typography
            sx={{ color: `${palette.primary.dark}` }}
            fontSize="14px"
            lineHeight="37.125px"
            display="inline"
            whiteSpace="nowrap"
          >
            {totalSize + 'GB'}
          </Typography>
          <Typography
            fontSize="14px"
            lineHeight="37.125px"
            display="inline"
            whiteSpace="nowrap"
          >
            {' '}
            / 10GB
          </Typography>
          <Typography
            sx={{ color: `${palette.primary.dark}` }}
            fontSize="14px"
            lineHeight="37.125px"
            display="inline"
            whiteSpace="nowrap"
          >
            Tải được tối đa dung lượng 500MB mỗi file
          </Typography>
        </Stack>
      </RowContent>
    </RowContainer>
  );
};

export default StudentModeInfo;
